import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { notification } from 'antd';

import { Button, Input, Form, Space } from 'antd';

import FormHeader from '@controls/form-header/form-header';

import { exception } from '@extensions/notification';
import { Permission, hasPermission } from '@enums/permission';

import { userLoaded } from '@store/actions';
import { useAppSelector, useAppDispatch } from '@store/hooks';

import { serverFetch } from '@flp/server';

import { IUserSession } from '@entities/user-session';
import { ITag } from '@entities/tag';

const Tag = () => {
    const { id } = useParams();

    const navigate = useNavigate();
    const [api, contextHolder] = notification.useNotification();

    const d = useAppDispatch();
    const userSession = useAppSelector<IUserSession>((s) => s.userSession);

    const [entity, setEntity] = useState<ITag>({ id: undefined, name: undefined });
    const [loading, setLoading] = useState<boolean>(false);
    const [manageTag] = useState<boolean>(hasPermission(userSession.permissions, Permission.ManageTags));

    useEffect(() => {
        if (!id) {
            return;
        }

        setLoading(true);

        serverFetch(`tags/${id}`, { method: 'GET' })
            .then((data) => {
                setEntity(data);
                setLoading(false);
            })
            .catch((ex) => {
                exception(api, 'Ошибка получения тега', ex, () => d(userLoaded(undefined)));
                setLoading(false);
            });
    }, []);

    const onSave = () => {
        setLoading(true);

        serverFetch(`tags`, { method: id ? 'PUT' : 'POST', bodyData: entity })
            .then(() => {
                setLoading(false);
                navigate(-1);
            })
            .catch((ex) => {
                setLoading(false);
                exception(api, 'Ошибка добавления тега', ex, () => d(userLoaded(undefined)));
            });
    };

    return (
        <>
            <FormHeader title={id ? 'Изменить тег' : 'Добавить тег'} />
            {!loading && (
                <Form colon={false} labelCol={{ span: 3 }} wrapperCol={{ span: 8 }} onFinish={onSave}>
                    <Form.Item
                        initialValue={entity.name}
                        required
                        label='Тег'
                        name='name'
                        rules={[
                            { required: true, message: 'Укажите название тега' },
                            {
                                validator: async (_, value) => {
                                    var path = id ? `tags/exist/${value}/${entity.id}` : `tags/exist/${value}`;
                                    let isExist = await serverFetch(path, { method: 'GET' })
                                        .then((data) => {
                                            return data;
                                        })
                                        .catch((ex) => {
                                            exception(api, 'Ошибка проверки тега', ex, () => d(userLoaded(undefined)));
                                        });

                                    if (isExist) return Promise.reject('Такой тег уже существует');
                                    return Promise.resolve();
                                },
                            },
                        ]}
                    >
                        <Input
                            disabled={!manageTag}
                            autoFocus
                            prefix='#'
                            onChange={(data) => {
                                setEntity({ ...entity, name: data.target.value });
                            }}
                        />
                    </Form.Item>
                    <Form.Item wrapperCol={{ offset: 3, span: 8 }}>
                        <Space size={'small'} style={{ float: 'right' }}>
                            <Button type='text' onClick={() => navigate(-1)}>
                                Отменить
                            </Button>
                            {manageTag && (
                                <Button type='primary' htmlType='submit' loading={loading}>
                                    Сохранить
                                </Button>
                            )}
                        </Space>
                    </Form.Item>
                </Form>
            )}

            {contextHolder}
        </>
    );
};

export default Tag;
